import React from 'react'

const Protection = ({ width, height, fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00006 15.1667C7.84006 15.1667 7.68007 15.1467 7.52673 15.1C4.06673 14.1467 1.56006 10.9133 1.56006 7.40667V4.48C1.56006 3.73333 2.10006 2.9267 2.7934 2.64003L6.50673 1.12001C7.4734 0.726679 8.53339 0.726679 9.49339 1.12001L13.2067 2.64003C13.9001 2.9267 14.4401 3.73333 14.4401 4.48V7.40667C14.4401 10.9067 11.9267 14.14 8.47339 15.1C8.32006 15.1467 8.16006 15.1667 8.00006 15.1667ZM8.00006 1.83335C7.62006 1.83335 7.24672 1.9067 6.88672 2.05336L3.1734 3.57334C2.8534 3.70667 2.56006 4.14 2.56006 4.48667V7.41335C2.56006 10.4733 4.76006 13.3 7.7934 14.14C7.92673 14.18 8.07339 14.18 8.20673 14.14C11.2401 13.3 13.4401 10.4733 13.4401 7.41335V4.48667C13.4401 4.14 13.1467 3.70667 12.8267 3.57334L9.1134 2.05336C8.7534 1.9067 8.38006 1.83335 8.00006 1.83335Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.5"
    />
  </svg>
)

export default Protection
